var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',[_vm._v("Funcionalidade: "+_vm._s(_vm.funcionalidade.nome))]),_c('h3',[_vm._v("ID: "+_vm._s(_vm.funcionalidade.idFuncionalidade))]),_c('p',[_vm._v("Funcionalidade ainda não implementada")]),_c('br'),_c('figure',{staticClass:"my-code"},[_c('figcaption',[_vm._v("Payload")]),_c('pre',[_c('code',[_vm._v(_vm._s(_vm.payload))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }